import {
    LibraryIframeActionE,
    ParentMessageAction,
    sendMessageToIframe,
} from '../../services/parentService'
import { tagsParser } from '../../services/tagsParser'
import { toggleLibrary } from './toggleLibrary'

// Use this function to instantly apply "open/close state"
const transformWithoutTransition = (element: HTMLElement, callback) => {
    const prevTransition = element.style.transition
    element.style.transition = 'none' // Disable transitions
    callback() // Execute some action
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const reflow = element.offsetHeight // Trigger a reflow, flushing the CSS changes
    element.style.transition = prevTransition // Re-enable transitions
}

type Props = {
    iframe: HTMLIFrameElement
    container: HTMLElement
    controlBtn: HTMLElement
    overlay: HTMLElement
    recIframe?: HTMLIFrameElement
}

const establishMsgListener = msgSwitch => {
    window.addEventListener('message', ({ data, origin }) => {
        if (!data || !data.action) return

        // Ignore messages that are not generated by parent
        if (EXT_MODE) {
            const extId = chrome?.runtime?.id
            if (
                (!extId || origin !== `chrome-extension://${extId}`) &&
                !Boolean(process.env.GUIDDE_LOCAL_SERVER)
            ) {
                return
            }
        }

        if (SDK_MODE && !window.location.host.includes('localhost')) {
            const apiKey = (window.guidde._apiKey || '').toLowerCase()
            const originCheck =
                origin.toLowerCase().includes(apiKey) ||
                origin.includes('localhost')
            if (!apiKey || !originCheck) {
                return
            }
        }

        const action: ParentMessageAction = data.action
        const { params } = data

        msgSwitch(action, params)
    })
}

export const libIframeMessageReceiver = ({
    iframe,
    container,
    controlBtn,
    overlay,
}: Props) => {
    establishMsgListener(async (action, params) => {
        switch (action) {
            case 'RESIZE_TO_PLAYER':
                if (params?.isSDKEmbed) {
                    container.style.width = '100vw'
                } else {
                    container.style.width = params.showSidePanel
                        ? 'max(50vw, 1000px)'
                        : 'max(700px, 25vw)'
                }
                container.style.height = 'max(50vh, 500px)'
                toggleLibrary(container, iframe, true)

                controlBtn.style.display = 'none'

                if (params?.playerPosition === 'center') {
                    container.style.bottom = 'calc(50% - max(25vh, 250px))'
                    container.style.right = 'calc(50% - max(300px, 12.5vw))'

                    overlay.style.display = 'block'
                }
                break

            case 'RESIZE_TO_NOTIFICATIONS':
                container.style.width = '420px'
                break

            case 'RESIZE_TO_NORMAL': {
                const isSDKEmbed = params?.isSDKEmbed

                container.style.width = isSDKEmbed
                    ? '100vw'
                    : 'max(650px, 35vw)'
                container.style.height = '100vh'
                container.style.bottom = '0'
                container.style.right = '0'
                if (params?.close !== undefined && !isSDKEmbed) {
                    transformWithoutTransition(container, () => {
                        toggleLibrary(container, iframe, !params.close)
                    })
                }

                overlay.style.display = 'none'

                controlBtn.style.display = isSDKEmbed ? 'none' : 'flex'
                break
            }
            case 'OPEN_MODAL_MODE':
                transformWithoutTransition(container, () => {
                    toggleLibrary(container, iframe, true)
                    container.style.width = '100vw'
                })
                break

            case 'GET_LIBRARY_STATE': {
                sendMessageToIframe(
                    iframe,
                    LibraryIframeActionE.INIT_LIBRARY_STATE,
                    {
                        isOpened:
                            container.style.transform === 'translateX(0%)',
                    }
                )
                break
            }
            case 'GET_LOCATION':
                iframe.contentWindow?.postMessage(
                    {
                        type: 'URL_CHANGED',
                        location: JSON.stringify(window.location),
                    },
                    iframe.src
                )
                break

            case 'GET_DEFAULT_TAGS': {
                const defaultTags = await tagsParser()
                iframe.contentWindow?.postMessage(
                    {
                        type: 'DEFAULT_TAGS_CHANGED',
                        data: JSON.stringify(defaultTags),
                    },
                    iframe.src
                )
                break
            }
            case 'OPEN_IFRAME':
                toggleLibrary(container, iframe, true)
                break

            case 'CLOSE_IFRAME':
                toggleLibrary(container, iframe, false)
                break

            default:
                break
        }
    })
}

export const recIframeMessageReceiver = recIframe => {
    establishMsgListener(action => {
        switch (action) {
            case 'OPEN_REC_IFRAME':
                recIframe.style.display = 'block'

                break

            case 'CLOSE_REC_IFRAME':
                recIframe.style.display = 'none'
                break

            case 'GET_LOCATION':
                recIframe.contentWindow?.postMessage(
                    {
                        type: 'URL_CHANGED',
                        location: JSON.stringify(window.location),
                    },
                    recIframe.src
                )
                break

            default:
                break
        }
    })
}
